export interface ContextInfo {
  type: string;
  id: number;
  name: string;
}

export interface StudentComment {
  id: number;
  student_id: number;
  teacher_id: number;
  teacher_name: string;
  category: 'clase_teorica' | 'clase_practica' | 'examen' | 'general';
  category_label: string;
  comment: string;
  context_type?: string | null;
  context_id?: number | null;
  context_info?: ContextInfo | null;
  created_at: string;
  updated_at: string;
  can_edit: boolean;
}

export interface StudentCommentFormData {
  student_id: number;
  category: 'clase_teorica' | 'clase_practica' | 'examen' | 'general';
  comment: string;
  context_type?: string | null;
  context_id?: number | null;
}

export const COMMENT_CATEGORIES = {
  clase_teorica: 'Clase Teórica',
  clase_practica: 'Clase Práctica',
  examen: 'Examen',
  general: 'General'
} as const;
